import FallbackLoader from './FallbackLoader';

export default FallbackLoader(() => import(/* webpackChunkName: "async-QueryBuilder" */'shared-components/components/QueryBuilder/qb'));
